import React from 'react';

import BankSVG from '../../../../../components/svg/Bank.svg';
import ShortLogo from '../../../../../components/svg/ShortLogo.svg';

export const IwocaToBankIllustration = ({
  icon,
}: {
  icon: React.ReactNode;
}) => (
  <div className="mb-[1.62rem] mt-[1.62rem] flex flex-col items-center justify-between m700:flex-row">
    <span>
      <img alt="Iwoca" src={ShortLogo} className="h-[108px]" />
    </span>

    {icon}

    <span>
      <img
        alt="Bank"
        src={BankSVG}
        className="h-[108px] rounded-[20px] bg-black-90 p-[30px_25px]"
      />
    </span>
  </div>
);
